let BASE_URL = process.env.REACT_APP_API_URL || "";

if (!BASE_URL) {
  if (process.env.NODE_ENV === "development") {
    BASE_URL = "http://localhost:3002";
  } else {
    BASE_URL = "https://app.shopalli.com.br";
  }
}

BASE_URL += "/api";

const API = {
  AUTH: {
    LOGIN: `${BASE_URL}/auth/login`,
    REGISTER: `${BASE_URL}/auth/register`,
    ME: `${BASE_URL}/auth/me`,
    FORGOT_PASSWORD: `${BASE_URL}/auth/forgot-password`,
    RESET_PASSWORD: `${BASE_URL}/auth/reset-password`,
  },
  COMPANIES: `${BASE_URL}/companies`,
  COMPANY_CONTACTS: (id) => `${BASE_URL}/companies/${id}/contacts`,
  COMPANY_DOCS: (id) => `${BASE_URL}/companies/${id}/documents`,
  COMPANY_CATEGORIES: (id) => `${BASE_URL}/companies/${id}/categories`,
  COMPANY_REGIONS: (id) => `${BASE_URL}/companies/${id}/regions`,
  CATEGORIES: `${BASE_URL}/categories`,
  REGIONS: `${BASE_URL}/regions`,
  ADS: `${BASE_URL}/ads`,
  AD: (id) => `${BASE_URL}/ads/${id}`,
  AD_STATUS: (id) => `${BASE_URL}/ads/${id}/status`,
  AD_CATEGORIES: (id) => `${BASE_URL}/ads/${id}/categories`,
  AD_REGIONS: (id) => `${BASE_URL}/ads/${id}/regions`,
  CHAT_CONVERSATIONS: `${BASE_URL}/chat/conversations`,
  CHAT_CONVERSATIONS_CUSTOMER: `${BASE_URL}/chat/conversations/customer`,
  CHAT_MESSAGES: (id) => `${BASE_URL}/chat/conversations/${id}/messages`,
  CHAT_MESSAGES_CUSTOMER: (id) => `${BASE_URL}/chat/conversations/${id}/messages/customer`,

  // ── Billing / Mercado Pago ───────────────────────────────────────────────
  BILLING: {
    CATALOG: `${BASE_URL}/billing/catalog`,
    ME: `${BASE_URL}/billing/me`,
    INSTALLMENTS: `${BASE_URL}/billing/installments`,
    CHECKOUT_PLAN: `${BASE_URL}/billing/checkout/plan`,
    CHECKOUT_OFFER: `${BASE_URL}/billing/checkout/offer`,
    ORDERS: `${BASE_URL}/billing/orders`,
    ORDER: (id) => `${BASE_URL}/billing/orders/${id}`,
    ORDER_STATUS: (id) => `${BASE_URL}/billing/orders/${id}/status`,
    ORDER_CANCEL: (id) => `${BASE_URL}/billing/orders/${id}/cancel`,
    SUBSCRIPTION_CANCEL: `${BASE_URL}/billing/subscription/cancel`,
    SUBSCRIPTION_REACTIVATE: `${BASE_URL}/billing/subscription/reactivate`,
    ENTITLEMENTS: `${BASE_URL}/billing/entitlements`,
    ENTITLEMENT_CANCEL: (id) => `${BASE_URL}/billing/entitlements/${id}/cancel`,
    ADMIN: {
      SUMMARY: `${BASE_URL}/billing/admin/summary`,
      ORDERS: `${BASE_URL}/billing/admin/orders`,
      REFUND: (mpPaymentId) => `${BASE_URL}/billing/admin/payments/${mpPaymentId}/refund`,
      WEBHOOKS: `${BASE_URL}/billing/admin/webhooks`,
      WEBHOOKS_RETRY: `${BASE_URL}/billing/admin/webhooks/retry`,
      PLANS_SYNC: `${BASE_URL}/billing/admin/plans/sync`,
    },
  },
};

export { BASE_URL, API };
